// extracted by mini-css-extract-plugin
export default {"delimiter":"hybrid-block-module__delimiter--x1PEO","activeBlock":"hybrid-block-module__activeBlock--AQIjz"};